/**
 * @ngdoc directive
 * @name WebCoreModule.directive:wcContinueIfValid
 * @restrict A
 * @requires ngController
 * @description
 * The wcContinueIfValid directive encorporates form validation into the submit button action. By applying this directive,
 * a click on the submit button will first check form validation. If the form is valid, the app will continue to the next
 * state defined in the state's 'workflow' data property. If the form is invalid, the app will not navigate and the user
 * will be allowed to make adjustments to their entries before trying navigation again.
 */

angular.module('WebCoreModule')
	.directive('wcContinueIfValid', ['$timeout', function($timeout) {
		return {
			restrict: 'A',
			required: '^ngController',
			controller: ['$state', '$element', '$scope', function($state, $element, $scope) {
				// jshint unused:true
				//written as a function so we can mock it in test code

				$state.$current.data = $state.$current.data || {};

				$state.$current.data.workflow = $state.$current.data.workflow|| null;

				if($state.$current.data.workflow) {
					this.isWorkflowEnabled = true;
				}
				else {
					this.isWorkflowEnabled = false;
				}

				this.getWorkflowData = function(){
						return $state.$current.data.workflow;
				};

				this.navigateToState = function(name, params, options) {
					var callingValues = {name: this.getWorkflowData().nextState, params: {}, options: {location: false, reload: false}};

					//if a single arg is passed, assume it's a state name and nav to it with other options as defaults
					if(arguments.length == 1) {
						callingValues.name = name;
					}
					//determine what was passed in and use it accordingly
					else if(arguments.length > 1) {
						if(name) {
							callingValues.name = name;
						}
						if(params) {
							callingValues.params = params;
						}
						if(options) {
							angular.extend(callingValues.options, options);
						}
					}

					$state.go(callingValues.name, callingValues.params, callingValues.options);
				};

				this.clickHandler = angular.bind(this, function(viewCtrl) {
						var callback = this.getWorkflowData().controllerContinueCallbackFunctionName;
						if(callback) {
							var retVal = viewCtrl[callback]($element);
							if(retVal) {
								//async case
								if(retVal.then) {
									retVal.then(angular.bind(this, function(obj){
										this.navigateToState(obj.name, obj.params, obj.options);
									}), angular.bind(this, function(obj) {
										this.navigateToState(obj.name, obj.params, obj.options);
									}));
								}
								//sync case
								else {
									this.navigateToState(retVal.name, retVal.params, retVal.options);
								}
							}
							//nothing returned - do default nav
							else {
								this.navigateToState();
							}
							//no callback - do default nav
						} else {
							this.navigateToState();
						}
				});
			}],
			link: function(scope, elem, attr, ctrl) {
				//these pieces aren't set up in a way that is easily unit testable.
				//leave them here in the link and allow e2e testing to pick them up.
				elem.on('click', function() {
					$timeout(function(){
						var viewCtrl = elem.controller();
						var formName = elem[0].form.name;


                        var formCtrl = scope[formName];

                        if(!formCtrl) {
                            //break out of isolate scope and then walk the tree for the form obj
                            formCtrl = scope.$parent[formName];
                        }

						// enable display of validation errors
						// viewCtrl.isFormSubmitted = true;

						// if form is valid, navigate to requested state and call the given function
						if(formCtrl.$valid) {
							formCtrl.$setPristine();
							if(ctrl.isWorkflowEnabled) {
								ctrl.clickHandler(viewCtrl);
							}
							else  {
								scope.$broadcast('navigateToNextState');
							}
						}
					}, 0);
				});

			}
		};
	}]);